import { createStyles, Theme } from '@material-ui/core/styles';

import { colors } from '@shared/theme/colours';

export const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {},
    card: {
      display: 'flex',
      flexDirection: 'column',
      padding: spacing(5),
      paddingBottom: 19,
      backgroundColor: colors.grey.body,
      overflow: 'visible',
    },
    addressContainer: {
      width: '100%',
    },
    headerText: {
      fontSize: 18,
      color: colors.black.darker,
      fontWeight: 500,
      marginBottom: spacing(5),
    },
    autocompleteTextField: {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
    },
    autocompleteAddressDoctor: {
      width: '100%',
    },
    textBottom: {
      display: 'flex',
      width: '100%',
      justifyContent: 'end',
      color: colors.grey.main,
      marginTop: spacing(7),
      cursor: 'pointer',
      '&:hover': {
        color: colors.black.darkest,
      },
    },
    selectRoot: {
      flex: '0 0 auto',
    },
    select: {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
    },
    selectOutlined: {
      padding: '0 12px',
      paddingRight: '24px !important',
    },
    selectIcon: {
      right: '0 !important',
    },
    selectValue: {
      textOverflow: 'initial',
    },
  });
